import {Menu} from "@mantine/core";
import {useTranslation} from "react-i18next";
import {WellEntity} from "@ots-frontend/ots-data";
import {useMemo} from "react";
import {useAuth} from "../../../providers/AuthProvider/AuthProvider";

export type WellAction = "NOT_SUPPORTED"

export type WellActionMenuDropdownProps = {
  well: WellEntity
  onActionClick?: (action: WellAction) => void
}

export const WellActionMenuDropdown = (props: WellActionMenuDropdownProps) => {
  const {well} = props

  const {hasAccess} = useAuth()
  const {t} = useTranslation(["common"])

  const actions: Set<WellAction> = useMemo(() => {
    const actions = new Set<WellAction>()
    if (hasAccess("well_edit")) {

    }
    return actions
  }, [well, hasAccess])

  return (
    <>
      {actions.size === 0 &&
        <Menu.Item>
          {t("common.action.none", "No Actions")}
        </Menu.Item>
      }
    </>
  )
}
